import * as yup from 'yup';

export const leadSchema = yup.object().shape({
  fullName: yup
    .string()
    .required('Full name is required')
    .min(2, 'Full name must be at least 2 characters')
    .matches(/^[A-Za-z\s'-]+$/, 'Full name must contain only letters'),

  phoneNumber: yup
    .string()
    .required('Phone number is required')
    .matches(
      /^(\d{3}-\d{3}-\d{4}|\d{10})$/,
      'Phone must be 10 digits or formatted as 123-456-7890'
    ),

    email: yup
    .string()
    .required('Email is required')
    .matches(
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      'Invalid email format (e.g. user@example.com)'
    ),

  businessName: yup
    .string()
    .required('Business name is required'),

  processingVolume: yup
    .string()
    .oneOf(
      ["$0", "$1,000 - $10,000", "$10,000 - $20,000", "Over $20,000"],
      'Select a valid processing volume'
    )
    .required('Processing volume is required'),

  message: yup
    .string()
    .nullable()
    .max(1000, 'Message cannot exceed 1000 characters'),
});